import React, { createContext, useState, useMemo, useContext, useEffect, ReactNode } from "react";
import { LoadingContextType } from "types";

const LoadingContext = createContext<LoadingContextType | null>(null);

interface LoadingProviderProps {
  children: ReactNode;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [titulo, setTitulo] = useState<string | undefined>();

  /**
   * Para prevenir que se muestre el titulo incorrecto, cuando se termina la
   * carga, se elimina cualquier titulo previo
   */
  useEffect(() => {
    if (!isLoading && titulo) {
      setTitulo(undefined);
    }
  }, [isLoading, titulo]);

  const state = useMemo<LoadingContextType>(
    () => ({
      isLoading,
      titulo,
      setIsLoading,
      setTitulo,
    }),
    [isLoading, titulo]
  );

  return (
    <LoadingContext.Provider value={state}>{children}</LoadingContext.Provider>
  );
};

export const useLoading = (): LoadingContextType => {
  const context = useContext(LoadingContext);

  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }

  return context;
};
